<template>
  <div class="home" :class="{ inactive: show === false }">
    <img src="../assets/header_home_mobile_v2.png" />

    <div>
      <h1>Só a Samsung tem a melhor <br />experiência de som e imagem</h1>
      <h3>Descubra a TV perfeita para você em 4 passos</h3>

      <div>
        <button id="btn_todos_modelos" v-on:click="onClickViewProducts()" class="link">
          <span v-if="windowWidth <= 768">Ver modelos</span>
          <span v-else>Ver todos os modelos</span>
        </button>
        <button id="btn_descobrir" v-on:click="onClickDiscover()" class="button primary">
          Quero descobrir
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  props: ["sendAnalytics", "show"],
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  mounted() {
    this.getSize();
  },
  methods: {
    onClickDiscover() {

      // Analytics Samsung
      // window.click_s_evar_event(
      //   "o",
      //   "26",
      //   "banner",
      //   "click",
      //   "quero-descobrir"
      // );
      // window.fbq('trackCustom', 'CE_HOT');
      // window.gtag('event', 'conversion', {
      //   'send_to': 'AW-844810653/fFGNCIT2mJACEJ2T65ID'
      // });
      // window.twq('event', 'tw-o2ja6-oc3xw', {});

      window.location.replace('');
    },
    onClickViewProducts() {

      // Analytics Samsung
      // window.click_s_evar_event(
      //   "o",
      //   "26",
      //   "banner",
      //   "click",
      //   "ver-todos-os-modelos"
      // );
      // window.fbq('trackCustom', 'CE_HOT');
      // window.gtag('event', 'conversion', {
      //   'send_to': 'AW-844810653/fFGNCIT2mJACEJ2T65ID'
      // });
      // window.twq('event', 'tw-o2ja6-oc3xw', {});

      this.$emit("onClickViewProducts");
    },
    getSize() {
      window.onresize = () => {
        this.windowWidth = window.innerWidth;
      };
    },
  },
};
</script>

<style lang="scss">
@import "../sass/main.scss";

.home {
  display: flex;
  flex-direction: column;

  img {
    width: 100%;
  }

  div {
    display: flex;
    flex-direction: column;

    justify-content: space-around;
    align-items: flex-start;

    padding: 1rem 2rem 1rem 2rem;
    gap: 1rem;

    max-width: 500px;

    color: rgba(0, 0, 0, 0.8);

    h1 {
      font-family: $font-family-title;
      font-size: 1.8rem;

      line-height: 2rem;
    }

    h3 {
      font-family: $font-family-default-bold;
      font-size: 1rem;

      line-height: 1.5rem;
    }

    div {
      display: flex;
      flex-direction: row;

      align-items: center;
      padding: 0;

      // button{
      //   font-size: 1.2rem;
      //   height: 44px;
      // }
    }

    @media (min-width: 478px) {
      h1 {
        font-size: 2.5rem;

        line-height: 3rem;
      }

      h3 {
        font-size: 1.5rem;

        line-height: 2rem;

        br {
          display: block;
        }
      }

      div {
        button {
          font-size: 1.6rem;
          height: 64px;
        }
      }
    }
  }
}

@media (min-width: $bp-mobile) {
  .home {
    position: relative;

    width: 100%;
    padding-bottom: 18%;

    img {
      position: absolute;
      width: 100%;

      content: url("../assets/header_home_desk_v2.png");
    }

    div {
      z-index: 1;
      gap: 0;
      max-width: 960px;
      padding: 3.8rem 2rem 1rem 2rem;

      h1 {
        font-size: 1.5rem;
        line-height: 2rem;
        color:#fff;
      }

      h3 {
        font-size: 0.8rem;
        color:#fff;

        br {
          display: none;
        }
      }
      span{
        color:#fff;
      }
      div {
        gap: 1rem;

        button {
          font-size: 0.6rem;
          height: 36px;
          border-color:#fff;
        }

        :nth-child(2) {
          padding: 0 2rem;
          background-color:#fff;
          color: rgba(0, 0, 0, 0.8);
        }
      }
    }

    @media (min-width: 980px) {
      div {
       

        h1 {
          font-size: 2rem;
          line-height: 2.5rem;
         
        }

        h3 {
          font-size: 1rem;
        }

        div {
          button {
            font-size: 0.8rem;
            margin-top: 0.8rem;
          }
        }
      }
    }

    @media (min-width: 1200px) {
      div {
    

        h1 {
          font-size: 2.3rem;
          line-height: 3rem;
        }

        h3 {
          font-size: 1.1rem;
        }

        div {
          button {
            font-size: 1.2rem;
            height: 46px;
          }
        }
      }
    }
  }
}

.inactive {
  display: none;
}
</style>
